import {
  MecPrice,
  PriceGroup,
  PriceType,
  MecProduct,
} from '@adapters/bigcommerce/types/product';

export const transformProductPrice = (item: MecProduct): PriceGroup | null => {
  const availableVariants = item.variants.filter(
    (variant) => variant.availableForSaleOnline
  );

  if (availableVariants.length === 0) {
    return null;
  }

  const getLowestPrice = (a: MecPrice, b: MecPrice): MecPrice =>
    a.value < b.value ? a : b;

  const getHighestPrice = (a: MecPrice, b: MecPrice): MecPrice =>
    a.value > b.value ? a : b;

  const priceValues: MecPrice[] = [];
  const basePriceValues: MecPrice[] = [];
  let priceType = PriceType.Regular;
  let epochEndDate: number | null = null;
  let isoEndDate: string | null = null;

  availableVariants.forEach((variant) => {
    // Collect regular prices
    if (variant.price.price) {
      priceValues.push(variant.price.price);
    } else if (variant.price.lowPrice && variant.price.highPrice) {
      priceValues.push(variant.price.lowPrice, variant.price.highPrice);
    } else if (variant.price.lowPrice) {
      priceValues.push(variant.price.lowPrice);
    } else if (variant.price.highPrice) {
      priceValues.push(variant.price.highPrice);
    }

    if (variant.price.basePrice) {
      basePriceValues.push(variant.price.basePrice);
    } else if (variant.price.baseLowPrice && variant.price.baseHighPrice) {
      basePriceValues.push(
        variant.price.baseLowPrice,
        variant.price.baseHighPrice
      );
    } else if (variant.price.baseLowPrice) {
      basePriceValues.push(variant.price.baseLowPrice);
    } else if (variant.price.baseHighPrice) {
      basePriceValues.push(variant.price.baseHighPrice);
    }

    if (variant.price.priceType === PriceType.Sale) {
      priceType = PriceType.Sale;
      epochEndDate = variant.price.epochEndDate;
      isoEndDate = variant.price.isoEndDate;
    } else if (
      variant.price.priceType === PriceType.Clearance &&
      priceType !== PriceType.Sale
    ) {
      priceType = PriceType.Clearance;
    }
  });

  if (priceValues.length === 0) {
    return null;
  }

  const lowPrice = priceValues.reduce(getLowestPrice);
  const highPrice = priceValues.reduce(getHighestPrice);

  const price =
    Math.abs(lowPrice.value - highPrice.value) < 0.01 ? lowPrice : null;

  let basePrice: MecPrice | null = null;
  let baseLowPrice: MecPrice | null = null;
  let baseHighPrice: MecPrice | null = null;

  if (basePriceValues.length > 0) {
    const baseLow = basePriceValues.reduce(getLowestPrice);
    const baseHigh = basePriceValues.reduce(getHighestPrice);

    basePrice =
      Math.abs(baseLow.value - baseHigh.value) < 0.01 ? baseLow : null;
    baseLowPrice = baseLow;
    baseHighPrice = baseHigh;
  }

  return {
    lowPrice,
    highPrice,
    price,
    priceType,
    epochEndDate,
    isoEndDate,
    basePrice,
    baseLowPrice,
    baseHighPrice,
  };
};
